<template>
  <transition name="bg-fade">
    <div
      v-if="visible"
      class="global-loader-overlay"
      aria-busy="true"
      role="status"
    >
      <div class="global-loader-spinner">
        <span class="sr-only">{{ loadingLabel }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

const SHOW_DELAY_MS = 200
const MIN_VISIBLE_MS = 300

export default {
  name: 'GlobalLoader',
  data() {
    return {
      visible: false,
      timer: null,
      shownAt: 0,
    }
  },
  computed: {
    ...mapGetters({ isLoading: 'ui/isLoading' }),
    loadingLabel() {
      const key = 'app.common.loading'
      const translated = this.$t(key)
      return translated === key ? 'Loading…' : translated
    },
  },
  watch: {
    isLoading(now) {
      if (now) this.scheduleShow()
      else this.scheduleHide()
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    scheduleShow() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.visible = true
        this.shownAt = Date.now()
      }, SHOW_DELAY_MS)
    },
    scheduleHide() {
      clearTimeout(this.timer)
      if (!this.visible) return
      const elapsed = Date.now() - this.shownAt
      const remaining = Math.max(0, MIN_VISIBLE_MS - elapsed)
      this.timer = setTimeout(() => {
        this.visible = false
      }, remaining)
    },
  },
}
</script>

<style scoped lang="scss">
.global-loader-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: progress;
}

.global-loader-spinner {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  border: 4px solid rgba(136, 229, 99, 0.25);
  border-top-color: #88e563;
  animation: gl-spin 0.8s linear infinite;
  background: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 0.6rem;
  box-sizing: content-box;
}

@keyframes gl-spin {
  to {
    transform: rotate(360deg);
  }
}

.bg-fade-enter-active,
.bg-fade-leave-active {
  transition: opacity 0.18s ease;
}

.bg-fade-enter,
.bg-fade-leave-to {
  opacity: 0;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
